import { render, staticRenderFns } from "./ToolbarAbout.vue?vue&type=template&id=418c7c8f"
import script from "./ToolbarAbout.vue?vue&type=script&lang=js"
export * from "./ToolbarAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports